export default {"src":"/_next/static/media/apple.e47c8317.svg","height":40,"width":40};